import { Injectable, computed, inject, signal } from '@angular/core';
import {
  BtnService,
  ETSConfirmDialogService,
  IFormSchema2,
  ISearchFormSchema,
  InfoDialogService,
  TableCol,
  TableService,
  TextCaseService,
  UtilityService as US,
  EVFunctions,
  KeyOfType,
} from 'ets-fe-ng-sdk';
import { Config } from '../configs/index.config';
import { Environment } from '../models/environment.model';
import { environment } from '../../environments/environment';
import { AsyncValidatorFn, FormControlOptions, ValidatorFn } from '@angular/forms';
import { Observable, forkJoin, map, tap } from 'rxjs';
import { ChartDataset, ChartOptions } from 'chart.js';
import { IFormSchema } from '../models/index.model';
import { uniq } from 'lodash-es';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
@Injectable({
  providedIn: 'root',
})
export class UtilityService extends US<Environment> {
  override config = Config;
  override environment: Environment = environment;
  public confirmDialogService = inject(ETSConfirmDialogService);
  public infoDialogService = inject(InfoDialogService);
  public tableService = inject(TableService);
  protected parent = inject(US);
  protected textCaseService = inject(TextCaseService);
  protected btnService = inject(BtnService);
  barChartThickness = signal(16);

  ninLength = signal(11);
  ninFormField = computed<IFormSchema>(() => ({
    field: 'nin',
    label: 'NIN',
    noFormat: true,
    minLength: this.ninLength(),
    maxLength: this.ninLength(),
    max: this.ninLength(),
    min: this.ninLength(),
    showValidation: true,
  }));
  readonly rrrLength = 12;
  readonly rrrFormField = computed<IFormSchema>(() => ({
    field: 'rrr',
    label: 'Bill Reference Number',
    noFormat: true,
    minLength: this.rrrLength,
    maxLength: this.rrrLength,
  }));
  ninSearchFormField = computed<ISearchFormSchema>(() => this.ninFormField() as ISearchFormSchema);

  readonly customLabels: { [x in 'pin' | 'cifmCertNo']: Partial<TableCol> } = {
    pin: { t: `CIIN Regd. No` },
    cifmCertNo: { t: `Proficiency Certificate` },
  };
  constructor() {
    super();
    this.tableService.generalColumnPropMap = {
      ...this.tableService.generalColumnPropMap,
      ...this.customLabels,
    };
    this.tableService.globalColumnsFormatter = (columns) =>
      columns?.map((x) => ({
        ...x,
        t: x.t ? this.customLabels[x.f as string]?.t || x.t : x.t,
      }));
    this.parent.info = this.info;
    this.btnService.btnClassConfig['secondary'] = {
      _mclass: 'btn btn-secondary cancelbtn-lg w-100',
    };
    this.btnService.btnClassConfig['clear'] = {
      _mclass: 'btn btn-clear  w-100',
    };
    this.btnService.defaultType = 'outline';
    // this.textCaseService.handleValueFormatter = (item: {
    //   value: any;
    //   formatter: (item?: any) => string | Promise<string> | Observable<string>;
    // }) => {
    //   if (!!item.formatter) {
    //     const res = item.formatter(item.value);
    //     if (item.value == 'A') {
    //       // const t = typeof res;
    //       debugger;
    //       // return res
    //     }
    //     return typeof res == 'object' ? (res as any) : of(res);
    //     // return res ? (isObservable(res) ? res : this.isAsync(res) ? (res as any) : of(res)) : of(null);
    //   } else return of(item.value);
    //   // const res = item.formatter ? item.formatter(item.value) : of(item.value);
    //   // // const res =  of(item.value);
    //   // if (!!item.formatter) debugger;
    //   // return res as any;
    // };
    // this.yesNoCellFormatter = (v) => {
    //   debugger;
    //   return 'FFF';
    // };
    // this.infoDialogService.overrideDialogConfig = { minHeight: '150px' };
  }

  exportHTMLToPDF(
    content: HTMLElement,
    fileName: string,
    config?: { width: number; widthMultiplier?: number; height?: number },
  ) {
    return html2canvas(content).then(async (canvas) => {
      let fileWidth = config?.width || canvas.width * (config?.widthMultiplier || 1);
      let fileHeight = config?.height || (canvas.height * fileWidth) / canvas.width;
      // debugger
      console.log([fileWidth, fileHeight]);
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jsPDF(
        canvas.height > canvas.width ? 'p' : 'l',
        'px',
        [fileWidth, fileHeight],
        true,
        // false
      );
      let position = 0;
      PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
      return await PDF.save(fileName + '.pdf', {
        returnPromise: true,
      });
    });
  }

  confirm = this.confirmDialogService.confirm;

  override info = this.infoDialogService.info;

  localDateToUtc<T extends string | null>(effectiveFrom: T | string) {
    return effectiveFrom ? new Date(effectiveFrom).toISOString() : (null as T);
  }

  /**
   * Formats a date string by adding a time component if it's missing.
   * For example '2020-01-01' becomes '2020-01-01T20:00:00Z'
   * @param date - The date string to format.
   * @returns The formatted date string with time.
   */
  dateWithTimeFormatter<T extends string | null | undefined>(date: T): T {
    return date && typeof date === 'string'
      ? date.includes('T')
        ? date
        : (`${date}T20:00:00Z` as any)
      : date;
  }
  countFormatter = (count: number) => this.numberPipe.transform(count)!;

  dayOrdinal = (day: number) => {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  override formControl = <T>(
    value?: T | null,
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | FormControlOptions,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[],
  ) => [value as any as T, validatorOrOpts!, asyncValidator!];

  readonly modalWidthExtraWide = computed(()=>'1200px');
  readonly modalWidthWide = computed(()=>'1000px');
  readonly modalWidthNarrow = computed(()=>'400px');
  /**
   * Returns the value of the current --primary variable
   */
  getColorByVariable = (variableName: string) => {
    const d = document.createElement('i');
    d.style.color = `var(--${variableName})`;
    document.body.appendChild(d);
    return window.getComputedStyle(d, null).getPropertyValue('color');
  };
  /**
   * Returns the value of the current --primary variable
   */
  getPrimaryColor = this.getColorByVariable('primary');

  /**
   * Returns the value of the current --secondary variable
   */
  getSecondaryColor = this.getColorByVariable('secondary');

  validateBulkData = <T>(
    data: T[],
    config: {
      filename?: string;
      idField: keyof T;
      dontNotify?: boolean;
      validators?: {
        [k in keyof T]?: {
          asyncFunction?: (row: T) => Observable<string | null>;
        };
      };
      labelMap?: { [k in keyof T]?: string };
      requiredFields?: (keyof T)[];
    },
  ) =>
    new Observable<{
      report: { [k in keyof T]?: string | null }[];
      hasErrors: boolean;
    }>((sub) => {
      // debugger;
      const { validators, labelMap, requiredFields, idField } = config;
      const requiredFieldsMap: { [k in keyof T]?: true } = {};
      const fields: (keyof T)[] = uniq([
        ...(requiredFields || []),
        ...((Object.keys(validators || {}) as any) || []),
      ]);
      if (!data?.length || !fields?.length) {
        sub.next({ hasErrors: false, report: [] });
        sub.complete();
      } else {
        requiredFields?.forEach((x) => (requiredFieldsMap[x] = true));
        let hasErrors = false;
        forkJoin(
          data.map((row) => {
            const respRow: { [k in keyof T]?: string | null } = {};
            return forkJoin(
              fields.map((field) =>
                new Observable<string | null>((fieldSub) => {
                  // debugger;
                  if (requiredFieldsMap[field] && row[field] == null)
                    fieldSub.next(
                      `${labelMap?.[field] || this.toTitleCase(String(field).toSentenceCase())} is required`,
                    );
                  else fieldSub.next(null);
                  fieldSub.complete();
                }).pipe(
                  tap((r) => {
                    // if (field == 'officePhoneNo') debugger;
                    respRow[field] = r;
                    if (r) hasErrors = true;
                  }),
                ),
              ),
            ).pipe(map(() => ({ rowID: row[idField], ...respRow })));
          }),
        ).subscribe({
          next: (report) => {
            sub.next({ report, hasErrors });
            sub.complete();
          },
          error: (e) => {
            sub.error(e);
          },
        });
      }
    }).pipe(
      tap((r) => {
        if (!config.dontNotify && r.hasErrors) {
          this.info(`Errors were encountered during the validation checks.`, 0, undefined, [
            {
              label: `Download Report`,
              icon: 'download',
              action: () => {
                this.arrayToCSV(
                  r.report,
                  `${config.filename || `Validation checks`} ${new Date().toISOString()}`,
                );
              },
            },
          ]);
        }
      }),
    );

  ngRXChecksumGenerator = <T>(payloadKey: keyof T) =>
    map((action: T) => ({
      action,
      checksum: Object.values(action[payloadKey] as any).join('~~'),
    }));

  formSchemaTyper = <T>(schema: IFormSchema2<T>[]) => schema as IFormSchema[];

  barChartOptions = (
    onClick?: (e: {
      index?: number;
      barLabel?: string;
      datasetLabel?: string;
      datasetValue?: ChartDataset['data'][0];
    }) => any,
  ) =>
    signal<ChartOptions<'bar'>>({
      onClick: (evt, elements, chart) => {
        const bars = chart.getElementsAtEventForMode(evt as any, 'nearest', { intersect: true }, true);
        if (bars.length === 0) return; // no bars

        const bar = bars[0];

        // Get index and label text
        const index = bar.index;
        const label: string = chart.data.labels?.[index] as string;
        let selectedDataset = chart.data.datasets[bar.datasetIndex];
        onClick?.({
          index,
          barLabel: label,
          datasetLabel: selectedDataset?.label,
          datasetValue: selectedDataset.data[index],
        });
      },
      responsive: true,

      scales: {
        y: {
          display: 'auto',
        },
        y1: {
          display: 'auto',
          position: 'right',
          grid: { drawOnChartArea: false },
        },
        x: {
          grid: {
            display: false,
          },
          //   ticks: {
          //     autoSkip: false,
          //     maxRotation: 0,
          //     minRotation: 0
          // },
          title: {
            display: true,
            text: '',
            align: 'end',
          },
        },
      },
      plugins: {
        tooltip: {
          callbacks: {
            label: function (tooltipItem) {
              // console.log(tooltipItem);
              var tooltipValue = tooltipItem.dataset.label || '';
              return tooltipValue
                ? `${tooltipValue}: ${tooltipItem.formattedValue}`
                : `${tooltipItem.formattedValue}`;
            },
          },
        },

        title: {
          display: true,
          text: '',
        },
      },
    });

  checkoutWithRRR = ({ rrr, publicKey }: { rrr: string; publicKey: string }) => {
    return new Observable((sub) => {
      // var randomnumber = Math.floor(Math.random() * 1101233);
      const paymentEngine = window['RmPaymentEngine'].init({
        key: publicKey,
        processRrr: true,
        transactionId: this.generateUUID(), //you are expected to generate new values for the transactionId for each transaction processing.
        // channel: 'CARD,USSD', //this field is used to filter what card channels you want enabled on the payment modal
        extendedData: {
          customFields: [
            {
              name: 'rrr',
              value: rrr, //rrr to be processed.
            },
          ],
        },
        onSuccess: (response) => {
          console.log('callback Successful Response', response);
          sub.next(response);
          sub.complete();
        },
        onError: (response) => {
          console.log('callback Error Response', response);
          sub.error(response);
        },
        onClose: () => {
          console.log('closed');
          sub.complete();
        },
      });
      paymentEngine.showPaymentWidget();
    });
  };

  generateColors(count: number) {
    return Array.from({ length: count }, this.randomHexColor);
  }

  private randomHexColor() {
    return `#${Math.floor(Math.random() * 0xffffff)
      .toString(16)
      .padStart(6, '0')}`;
  }

  toCamelCase(sentence: string) {
    return sentence.toLowerCase().replace(/\s+(.)/g, (match, group) => group.toUpperCase());
  }

  dateParser = (date: any) => (date ? new Date(date).toLocaleDateString() : '-');
  timeParser = (date: any) => (date ? new Date(date).toLocaleTimeString() : '-');
  booleanFormatter = (val: any) => (val ? 'Yes' : 'No');

  formatCTResponse = <T>(
    list: T[],
    codeField: KeyOfType<T, string>,
    titleField: KeyOfType<T, string | null | undefined>,
  ) => {
    const map = list.toMap(codeField);
    const codeFormatter = (code: string | undefined | null) =>
      code != null ? EVFunctions.strConcatenator(code, map[code]?.[titleField] as string).label : null;
    const findDescription = (code: string | undefined | null) =>
      code != null ? map[code]?.[titleField] : null;
    return {
      list,
      map,
      codeFormatter,
      findDescription,
      inputSchema: <IFormSchema>{
        type: 'autocomplete',
        options: list,
        valueField: codeField as string,
        labelField: [codeField as string, titleField as string],
      },
      tableSchema: <TableCol>{
        formatter: codeFormatter,
      },
    };
  };
}
